module.exports = __webpack_public_path__ + "static/main8-8482dfcf7d2a6a46d05996fdd9c2f3d1.png";